import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitchars'
})
export class SplitcharsPipe implements PipeTransform {

  transform(tag: string, char: string, col: number): unknown {
    let subject = tag.split(char);

    if(subject[col]!== '') {
      return subject[col];
    }
  }

}
